export default class HTMLPopup {
    protected _content:HTMLElement;
    constructor(htmlContent:string) {
        this._content = document.createElement("div");
        this._content.innerHTML = htmlContent;
        this._content.classList.add("wiener_popup");
    }

    public get content(){
        return this._content;
    }
}